import { Controller } from "@hotwired/stimulus"

// P24 — Chrono du match en cours : le serveur rend « 12 min » / « 1 h 05 »
// (LiveHelper#chrono_label) ; ici on recalcule le même libellé toutes les
// 30 s. Survit aux morphs Turbo : la valeur est relue à chaque connect.
export default class extends Controller {
  static values = { startedAt: String }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 30000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const startedAt = Date.parse(this.startedAtValue || this.element.dataset.startedAt)
    if (Number.isNaN(startedAt)) return

    const minutes = Math.max(0, Math.floor((Date.now() - startedAt) / 60000))
    const label = minutes < 60
      ? `${minutes} min`
      : `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, "0")}`
    this.element.textContent = `⏱ ${label}`
  }
}
